const Unit = (() => {
  // Misc
  const unit = Symbol("@masaeedu/fp/unit");

  return { unit };
})();

module.exports = Unit;
